import React from "react";
import AddCollectionModal from "./add-collection-modal";

interface AddCollectionProps extends React.HTMLAttributes<HTMLDivElement> {
  onSuccess?: () => void;
}

const AddCollection: React.FC<AddCollectionProps> = ({
  onSuccess,
  ...rest
}) => {
  return (
    <>
      <AddCollectionModal onSuccess={onSuccess}>
        <div className="add-collection" {...rest}>
          <img src="/cross-grey.svg" />
        </div>
      </AddCollectionModal>
      <style jsx>{`
        .add-collection {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #e7e7e7;
          background: #f7f7f7;
          cursor: pointer;
        }

        @media (max-width: 768px) {
        }
      `}</style>
    </>
  );
};

export default AddCollection;
